
import { graphql, type ResultOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const EditUnavailabilityReasonMutation = graphql(`
  mutation EditUnavailabilityReason($unavailabilityId: ID!, $reason: String) {
    editUnavailabilityReason(unavailabilityId: $unavailabilityId, reason: $reason) {
      id
      reason
    }
  }
`);

export type EditUnavailabilityReasonData = ResultOf<typeof EditUnavailabilityReasonMutation>;

export interface EditUnavailabilityReasonVars {
  readonly unavailabilityId: string;
  readonly reason?: string | null;
}

export function editUnavailabilityReason(
  vars: EditUnavailabilityReasonVars,
  signal?: AbortSignal,
): Promise<EditUnavailabilityReasonData> {
  return gqlRequest(EditUnavailabilityReasonMutation, vars, { signal });
}

export const RemoveUnavailabilityMutation = graphql(`
  mutation RemoveUnavailability($unavailabilityId: ID!) {
    removeUnavailability(unavailabilityId: $unavailabilityId) {
      id
    }
  }
`);

export type RemoveUnavailabilityData = ResultOf<typeof RemoveUnavailabilityMutation>;

export interface RemoveUnavailabilityVars {
  readonly unavailabilityId: string;
}

export function removeUnavailability(
  vars: RemoveUnavailabilityVars,
  signal?: AbortSignal,
): Promise<RemoveUnavailabilityData> {
  return gqlRequest(RemoveUnavailabilityMutation, vars, { signal });
}
